/// 表单显示类型
const FormViewType = {
    // 新增
    Add: 'add',
    // 编辑
    Edit: 'edit',
    // 查看
    View: 'view',
    //草稿
    Draft: 'draft',
};

export default FormViewType;
